export default "__VITE_ASSET__DILvRh0i__"